import { io } from 'socket.io-client';

let socketInstance = null;

/**
 * Gets or creates a singleton socket connection.
 * @param {string|null} token - Authentication token.
 * @param {string|null} partnerId - Unique partner ID.
 * @returns {Socket} The socket instance.
 */
export const getSocket = (token = null, partnerId = null) => {
  if (!socketInstance) {
    console.log('Creating single socket connection...');
    
    socketInstance = io(`${process.env.REACT_APP_CHAT_SERVER}`, {
      autoConnect: false,
      auth: {
        source: 'widget',
        token: token || undefined,
        partnerId: partnerId || undefined,
      },
      transports: ['websocket'],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
    });

    socketInstance.on('connect', () => {
      console.log('Socket connected:', socketInstance.id);
    });

    socketInstance.on('disconnect', (reason) => {
      console.log('Socket disconnected:', reason);
    });

    socketInstance.on('connect_error', (error) => {
      console.error('Socket connection error:', error);
    });
  }

  // Update auth metadata if it has changed
  let authChanged = false;
  if (token && socketInstance.auth.token !== token) {
    socketInstance.auth.token = token;
    authChanged = true;
  }
  if (partnerId && socketInstance.auth.partnerId !== partnerId) {
    socketInstance.auth.partnerId = partnerId;
    authChanged = true;
  }

  // If already connected and auth details changed, we might need to notify the server
  // or reconnect depending on server requirements. For now, we update the object
  // so future connections (reconnects) use the new data.
  
  if (!socketInstance.connected) {
    socketInstance.connect();
  } else if (authChanged) {
    // Optional: If you need the server to know immediately about the new token/partnerId
    // you could emit a 'refresh-auth' event or similar if the server supports it,
    // or just disconnect/reconnect.
    // socketInstance.disconnect().connect();
  }

  return socketInstance;
};

export const disconnectSocket = () => {
  if (socketInstance) {
    socketInstance.disconnect();
    socketInstance = null;
  }
};

export const isSocketConnected = () => {
  return socketInstance?.connected || false;
};

export const getSocketInstanceId = () => {
  return socketInstance ? socketInstance.id : 'no-socket';
};
